import { useEffect, useState } from "react";
import { ATTRIBUTION_VISITOR_COMMAND } from "./embedCollector";
import { parentIsSameOrigin } from "./hostedCollection";

export const attributionVisitorFrom = (event, sender) => {
  const payload = event && event.data;
  if (!payload || typeof payload !== "object") return null;
  if (event.source !== window.parent) return null;
  if (payload.from !== sender || payload.command !== ATTRIBUTION_VISITOR_COMMAND) return null;
  const uuid = payload.data && payload.data.visitorUuid;
  return typeof uuid === "string" && uuid.length > 0 ? uuid : null;
};

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const slotVisitorId = (frame) => {
  const id = frame.__odAttribution && frame.__odAttribution.id;
  return typeof id === "string" && UUID_PATTERN.test(id) ? id : null;
};

const sameOriginParentVisitorId = () => {
  if (!parentIsSameOrigin()) return null;
  try {
    return slotVisitorId(window.parent);
  } catch (e) {
    return null;
  }
};

export const sharedAttributionVisitorId = () => {
  if (typeof window === "undefined") return null;
  return slotVisitorId(window) || sameOriginParentVisitorId();
};

export const isTopLevel = () => window.top === window;

export const acceptsPostedVisitor = () => !isTopLevel() && !window.__odAttrCollected;

export const useAttributionVisitor = (sender) => {
  const [visitorUuid, setVisitorUuid] = useState(null);

  useEffect(() => {
    const listener = (event) => {
      const uuid = attributionVisitorFrom(event, sender);
      if (uuid) setVisitorUuid(uuid);
    };
    window.addEventListener("message", listener, false);
    return () => window.removeEventListener("message", listener, false);
  }, [sender]);

  return acceptsPostedVisitor() ? visitorUuid : null;
};
